import { SportCourt } from "apis/SportCourtAPI";
import { AppDispatch } from "store/store";

export const SPORT_COURT_ACTIONS = {
  FETCH: "FETCH",
};

export const fetchAction = (value: SportCourt[]) => (dispatch: AppDispatch) => {
  dispatch({
    type: SPORT_COURT_ACTIONS.FETCH,
    payload: { value },
  });
};
